import React, { Component } from 'react';
import { Switch, Route, Redirect, withRouter } from 'react-router-dom';
import { TransitionGroup, CSSTransition } from 'react-transition-group';
import { Swipeable, defineSwipe } from 'react-touch';

import { Styleguide } from './components/theme';
import { Menu } from './components/navigation';
import { Routes } from './Routes';
import { Canvas } from './components/theme';
import { isMobile } from './components/util';

class App extends Component {

  constructor(props) {
    super(props);

    this.state = {
      activePage: 0,
      activeScroll: true,
      classes: []
    };

    this.props.history.listen((location) => {
      const pathName = location.pathname;
      this.setActivePage(pathName);
      this.setCursor(pathName);
    });

  }

  componentDidMount = () => {
    const pathname = this.props.location.pathname;
    this.setActivePage(pathname);
    this.setCursor(pathname);
  }

  setCursor = (pathname) => {
    const classes = ['App'];

    if (pathname !== '/economiseste-energie') {
      classes.push('brush-cursor');
    }

    this.setState({ classes });
  }

  setActivePage = (pathname) => {
    for (const [key, value] of Routes.entries()) {
      if (value.path === pathname) {
        this.setState({ activePage: key });
        break;
      }
    }
  }

  wheelHandler = (e) => {
    const activePage = this.state.activePage;
    const direction = e.deltaY > 0 ? 'down' : 'up';
    const goTo = (route) => this.props.history.push(route);

    if (this.state.activeScroll) {
      this.setState({
        activeScroll: false
      }, () => {
        if (direction === 'down' && activePage < Routes.length - 1) {
          goTo(Routes[activePage + 1].path);
        } else if (direction === 'up' && activePage > 0) {
          goTo(Routes[activePage - 1].path);
        }
        setTimeout(() => this.setState({ activeScroll: true }), 750);
      })
    }
  }

  swipe = (direction) => {
    if (isMobile) {
      const activePage = this.state.activePage;
      const goTo = (route) => this.props.history.push(route);

      if (direction === 'down' && activePage < Routes.length - 1) {
        goTo(Routes[activePage + 1].path);
      } else if (direction === 'up' && activePage > 0) {
        goTo(Routes[activePage - 1].path);
      }
    }

  }

  render() {
    const routeComponent = Routes.map(({ path, component }, key) => <Route exact path={path} component={component} key={key} />);
    const { location } = this.props;
    const swipe = defineSwipe({ swipeDistance: 50 });

    return (
      <Swipeable
        onSwipeUp={() => this.swipe('down')}
        onSwipeDown={() => this.swipe('up')}
        config={swipe}
      >
        <div className={this.state.classes.join(' ')}
          onWheel={this.wheelHandler}
        >

          <Menu routes={Routes} />
          {
            !isMobile && this.state.activePage > 0 && <Canvas routeKey={this.state.activePage} />
          }
          <TransitionGroup>
            <CSSTransition
              key={location.key}
              classNames={location.pathname.replace('/', '')}
              timeout={{ appear: 2500, enter: 5000, exit: 2000 }}
              appear={true}
              enter={true}
            >
              <Switch location={location}>
                {routeComponent}
                <Route exact path="/styleguide" component={Styleguide} />
                <Redirect to="/economiseste-energie" />
              </Switch>
            </CSSTransition>
          </TransitionGroup>

        </div>
      </Swipeable>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/App.js